/* eslint-disable prefer-const */
import cookie from 'cookie'

function props () {
    const baseUri = window.config.getApiBaseUri()
    const token = cookie.parse(document.cookie).dek_eshop_token
    const headers = new Headers({
        Authorization: 'Bearer ' + token,
    })
    return {
        baseUri,
        headers,
    }
}

interface GetOptions {
    search?: URLSearchParams
    signal?: AbortSignal
    headers?: Headers
}

export default {
    get (uri: string, options: GetOptions = {}): Promise<Response> {
        let baseUri, headers
        ({ baseUri, headers } = props())

        const url = new URL(baseUri + uri)
        if (options.search) {
            url.search = options.search.toString()
        }

        options.headers = headers

        return fetch(url.toString(), options)
    },
    post (uri: string, payload: unknown = undefined, method = 'POST'): Promise<Response> {
        let baseUri, headers
        ({ baseUri, headers } = props())
        headers.set('Content-Type', 'application/json')
        const body = payload ? JSON.stringify(payload) : undefined

        return fetch(baseUri + uri, {
            method,
            headers,
            body,
        })
    },
    put (uri: string, payload: unknown): Promise<Response> {
        return this.post(uri, payload, 'PUT')
    },
    patch (uri: string, payload: unknown): Promise<Response> {
        return this.post(uri, payload, 'PATCH')
    },
    delete (uri: string): Promise<Response> {
        let baseUri, headers
        ({ baseUri, headers } = props())
        const method = 'DELETE'

        return fetch(baseUri + uri, {
            method,
            headers,
        })
    },
}
